<template lang="pug">
  .program-container.column.center
    program-header(v-if='program' @toggleVideoModal='toggleVideoModal')
    .main-container(v-if='program')
      .row
        .item-1.m-right-2
          program-info
        .item-1.m-left-1
          program-details
      program-resources
    used-content-drawer
    register-use-modal(v-if='showRegisterUseModal')
    video-modal(v-if='showVideoModal' :videoUrl='activeProgramLanguage.youtubeLink' @close='toggleVideoModal')
    ask-for-information-modal(v-if='showAskForInformationModal')
    thanks-modal(v-if='showThanksModal' :style='thanksModalWidth')
    add-resource-modal(v-if='showAddResourceModal')
    share-content-modal(v-if='showShareContentModal')
    done-modal(v-if='showDoneModal' :style='doneModalWidth')
    create-sharing-group-modal(v-if='showCreateSharingGroupModal')
    edit-sharing-group-modal(v-if='showEditSharingGroupModal')
    add-sharing-group-members-modal(v-if='showAddSharingGroupMembersModal')
</template>

<script>
import { mapState, mapActions } from 'vuex'
import amplitude from 'amplitude-js'
import DoneModal from '@/components/Modals/DoneModal'
import VideoModal from '@/components/EducationalPrograms/VideoModal'
import AskForInformationModal from '@/components/EducationalPrograms/AskForInformationModal'
import ThanksModal from '@/components/EducationalPrograms/ThanksModal'
import AddResourceModal from '@/components/Resource/AddResource'
import RegisterUseModal from '@/components/RegisterUseModal/RegisterUseModal'
import UsedContentDrawer from '../components/UsedContent/UsedContentDrawer'
import ShareContentModal from '../components/EducationalPrograms/ShareContentModal'
import CreateSharingGroupModal from '@/components/Modals/CreateSharingGroupModal'
import EditSharingGroupModal from '@/components/Modals/EditSharingGroupModal'
import AddSharingGroupMembersModal from '@/components/Modals/AddSharingGroupMembersModal'
import ProgramInfo from '../components/EducationalPrograms/ProgramInfo'
import ProgramDetails from '../components/EducationalPrograms/ProgramDetails'
import ProgramResources from '../components/EducationalPrograms/ProgramResources'
import ProgramHeader from '../components/EducationalPrograms/ProgramHeader'
import { languagesCodesToString } from '../constants/languages'

export default {
  name: 'EducationalProgram',
  components: {
    DoneModal,
    ProgramInfo,
    ProgramDetails,
    ProgramResources,
    ProgramHeader,
    CreateSharingGroupModal,
    EditSharingGroupModal,
    AddSharingGroupMembersModal,
    ShareContentModal,
    UsedContentDrawer,
    RegisterUseModal,
    VideoModal,
    AskForInformationModal,
    ThanksModal,
    AddResourceModal
  },
  data() {
    return {
      showVideoModal: false
    }
  },
  watch: {
    program(nextProgram, prevProgram) {
      amplitude.getInstance().logEvent('Educational Program Detail', {
        id: nextProgram.id,
        name: nextProgram.name,
        category: this.programCategory ? this.programCategory.name : ''
      })
    }
  },
  computed: {
    ...mapState({
      program: state => state.educationalProgram.educationalProgram,
      categories: state => state.dashboard.categories,
      showAskForInformationModal: state => state.behavior.askForInformationModal.show,
      showDoneModal: state => state.behavior.doneModal.show,
      showThanksModal: state => state.behavior.thanksModal.show,
      showCreateSharingGroupModal: state => state.behavior.createSharingGroupModal.show,
      showAddSharingGroupMembersModal: state => state.behavior.addSharingGroupMembersModal.show,
      showEditSharingGroupModal: state => state.behavior.editSharingGroupModal.show,
      showShareContentModal: state => state.behavior.shareContentModal.show,
      showAddResourceModal: state => state.behavior.addResourceModal.show,
      showRegisterUseModal: state => state.behavior.registerUseModal.show,
      locale: state => state.behavior.locale,
      innerLocale: state => state.behavior.innerLocale,
      userInfo: state => state.userInfo.userInfo,
      customFields: state => state.userInfo.customFields
    }),
    activeProgramLanguage() {
      return this.program.localizedEducationalPrograms.find(pr => languagesCodesToString[pr.locale] === this.innerLocale)
    },
    doneModalWidth() {
      return '--max-width: 600px'
    },
    programCategory() {
      return this.categories.find(category => category.id === this.program.categoryId)
    },
    thanksModalWidth() {
      return '--max-width: 580px'
    }
  },
  async created() {
    if (!this.customFields) await this.getUserCustomFields()
    const locale = this.$route.query.locale
    await this.getEducationalProgram({ id: this.$route.params.id, locale: locale || this.locale })
    this.changeInnerLocale(locale || this.program.locale)
    this.hydrateCategories()
    this.hydrateAges()
  },
  methods: {
    ...mapActions([
      'getEducationalProgram',
      'hydrateCategories',
      'hydrateAges',
      'changeInnerLocale',
      'getUserCustomFields'
    ]),
    toggleVideoModal() {
      this.showVideoModal = !this.showVideoModal
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/sizes';

.program-container {
  min-height: calc(100vh - #{$footer-height});
  width: 100%;
}
</style>
